import React, { useEffect, useMemo } from "react";
import { useStudentGroup } from "store/studentGroup/selectors";
import ListStudentGroup from "./gradeBook/listStudentGroup";
import CreateStudentGroup from "./gradeBook/createStudentGroup";
import { useDispatch } from "react-redux";
import { updateStudentGroup } from "store/studentGroup/actions";
import {
  handleCreateStudentGroup,
  handleDelteStudentGroup,
  handleGetStudentGroup,
  handleListByClassId,
} from "store/studentGroup/thunks";
import SelectDiffernation from "./differnation/selectDiffernation";
import * as Sentry from "@sentry/react";
import SentryWrap from 'components/Sentry';
import { useCurrentClass } from "store/classes/selectors";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { checkStudentIds } from "./helper";
import { useCurrentUser } from "store/users/selectors";

const StudentGroupGradeBook = () => {
  const dispatch = useDispatch();
  const showAlert = useAlert();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const {
    data = [],
    open = false,
    type = "",
    createGroup = false,
    previewData = null,
    selectedDataForDiff = [],
    selection_data_for_diff = [],
    groupsData = [],
  } = useStudentGroup();

  useEffect(() => {
    dispatch(handleListByClassId(currentClass?.id));
  }, [currentClass?.id]);

  useEffect(() => {}, [groupsData]);

  /**
   * Updates the state of the student group modal
   * @param {Object} data The data to be updated
   * @returns {Promise} A promise that resolves when the state is updated
   */
  const updateState = async (data) => {
    await dispatch(updateStudentGroup(data));
  };

  /**
   * Closes the student group modal and resets its state
   * @returns {Promise} A promise that resolves when the state is updated
   */
  const onCloseHandler = async () => {
    await dispatch(updateStudentGroup({ open: false, type: "" }));
    await dispatch(handleGetStudentGroup(currentUser?.id))
  };

  /**
   * Submits the student group data to the server and updates the state of the student group modal
   * @param {Object} data The student group data to be submitted
   * @returns {Promise} A promise that resolves when the state is updated
   */
  const handleSubmit = async (data) => {
    await dispatch(handleCreateStudentGroup(data));
    await updateState({ createGroup: false, previewData: null });
  };

  /**
   * Opens the student group modal in preview mode for the given index
   * @param {number} index The index of the student group to be previewed
   * @returns {Promise} A promise that resolves when the state is updated
   */
  /*******  ebfd9e75-d5e7-407f-afe6-b095ad609e44  *******/ /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * @param {number} index - The index of the student group to be previewed.
   * @returns {Promise} A promise that resolves when the state is updated to open the preview.
   */
  const handleOpenPreview = async (index) => {
    const selectedData = data[index];
    await dispatch(
      updateStudentGroup({
        open: true,
        previewData: selectedData,
        createGroup: true,
      })
    );
  };

  /**
   * Deletes a student group by ID
   * @param {number} id - The ID of the student group to be deleted
   * @returns {Promise} A promise that resolves when the student group is deleted
   */
  const handleDeleteData = async (id) => {
    await dispatch(handleDelteStudentGroup(id));
  };

  const selectedData = useMemo(() => {
    const groupData = groupsData?.map((element) => element?.id);
    const xy = selection_data_for_diff?.filter(
      (x) => !groupData?.includes(x.id)
    );
    return xy;
  }, [groupsData, selection_data_for_diff]);


  /**
   * Handles the selection of a student group for differnation and updates the state
   * @param {number} selectedData - The ID of the selected student group
   * @returns {Promise} A promise that resolves when the state is updated
   */
  const handleSelectedDataForDiffernation = async (selectedData) => {
    try {
      const groupData = groupsData?.map((element) => element?.id);
      const xy = selection_data_for_diff?.filter(
        (x) => !groupData?.includes(x.id)
      );
      const checkIdExistOnGroup = checkStudentIds(xy, groupsData);

      if (checkIdExistOnGroup) {
        showAlert("Student is Alreay Exist on Group .. You need to edit the group first", "error");
        return;
      }
      const filterData = selection_data_for_diff?.find(
        (x) => selectedData === x.id
      );
      await dispatch(
        updateState({ selectedDataForDiff: filterData, type: "", open: false })
      );
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return (
    <SentryWrap>
    <div className="">
      {open && type === "listStudentGroup" && (
        <ListStudentGroup
          open={open}
          onClose={onCloseHandler}
          updateState={updateState}
          handleOpenPreview={handleOpenPreview}
          data={data}
          handleDeleteData={handleDeleteData}
        />
      )}

      {open && type === "selectDiffernation" && (
        <SelectDiffernation
          open={open}
          onClose={onCloseHandler}
          data={selection_data_for_diff}
          selectedData={selectedData}
          selectedDataForDiff={selectedDataForDiff}
          handleSelectedDataForDiffernation={handleSelectedDataForDiffernation}
        />
      )}

      {open && createGroup && (
        <CreateStudentGroup
          open={open}
          onClose={async () => {
            await updateState({ createGroup: false, previewData: null });
          }}
          data={data}
          updateState={updateState}
          handleSubmit={handleSubmit}
          previewData={previewData}
        />
      )}
    </div>
    </SentryWrap>
  );
};

export default StudentGroupGradeBook;
